(function ($) {
  $.fn.fileDragAndDrop = function (options) {
    var $self = $(this);
    if ($(this).length == 0)
      return;

    var defaults = {
      addDropStyle: function ($dropArea) {
        if (!$dropArea.hasClass('over'))
          $dropArea.addClass('over');
      },
      removeDropStyle: function ($dropArea) {
        $dropArea.removeClass('over');
      },
      onDropMissed: function ($dropArea, e) {
        defaults.removeDropStyle($dropArea);
      },
      onFileDrop: function ($dropArea, files, e) {
        defaults.removeDropStyle($dropArea);
      },
      onDropIsNotFile: function ($dropArea, e) {
        defaults.removeDropStyle($dropArea);
      }
    };

    options = $.extend(defaults, options);

    function preventDefault(e) {
      e.stopPropagation();
      e.preventDefault();
    }

    function setDragEffect(e, effect) {
      e.originalEvent.dataTransfer.dropEffect = effect;
    }

    function isOnFileInput(e) {
      return e.target.tagName.toLowerCase() == "input" && e.target.type.toLowerCase() == "file";
    }

    $(document).on('dragenter dragover', function (e) {
      if (!isOnFileInput(e)) {
        preventDefault(e);
        setDragEffect(e, 'none');
        options.addDropStyle($self);
      }
    });

    $(document).on('dragleave', function (e) {
      options.removeDropStyle($self);
    });

    $(this).each(function () {
      var $this = $(this);

      if (!$this.is('.drop-area'))
        $this.addClass('drop-area');

      $this.bind('dragenter dragover', function (e) {
        preventDefault(e);
        setDragEffect(e, 'copy');
        options.addDropStyle($this);
      });

      $this.bind('dropmissed', function (e) {
        itemMissed(e);
      });

      this.addEventListener('drop', itemDropped, false);
      document.addEventListener('drop', itemMissed, false);

      function itemMissed(e) {
        // if dropping on a file input, we want to allow the drop
        if (!isOnFileInput(e)) {
          preventDefault(e);
        }

        options.onDropMissed($this, e);
      }

      function itemDropped(e) {
        preventDefault(e);
        $('.drop-area').not($this).trigger('dropmissed', e);

        var files = e.dataTransfer.files;

        if (files.length > 0) {
          options.onFileDrop($this, files, e);
        } else {
          options.onDropIsNotFile($this, e);
        }
      }
    });
  }
})(jQuery);
